// eslint-disable-next-line max-classes-per-file
import LogRocket from 'logrocket';

import { R } from '@genially/commons';

import { AppEnv } from '../../../../config/appEnv';
import config from '../../../../config/config';
import type { TrackIntegration } from '../../services/track/TrackIntegration';
import type { TrackServiceEvent } from '../../services/track/TrackService';
import { LogRocketEvent } from './LogRocketEvent';

const { equals } = R;

const trackLogRocketEvent = (event: LogRocketEvent) => {
  const { name, unique, ...rest } = event.payload;

  if (config.appEnv === AppEnv.Local || config.appEnv === AppEnv.Dynamic) {
    // eslint-disable-next-line no-console
    console.log('This video recording event would be tracked in production', {
      name,
      unique: unique !== false,
      eventProperties: rest,
    });
    return;
  }

  LogRocket.track(name, rest);
};

export class LogRocketAnonymousIntegration implements TrackIntegration {
  private readonly uniqueEvents: LogRocketEvent[] = [];

  private readonly isActive: boolean;

  public constructor() {
    this.isActive = LogRocket !== undefined;
  }

  public get active(): boolean {
    return this.isActive;
  }

  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
  start(): void {}

  public trackEvent(event: TrackServiceEvent): void {
    const isCompatible = event instanceof LogRocketEvent;

    if (!this.isActive || !isCompatible) {
      return;
    }

    /* Video events are normally used to be able to tag videos to be easily searchable
    that is why unique is true by default. Most times there is no need to track events twice
    because doing it once it will be enough to find it. */
    const isUnique = event.payload.unique !== false;
    if (isUnique && this.uniqueEvents.some(e => equals(e, event))) {
      return;
    }

    try {
      trackLogRocketEvent(event);

      if (isUnique) {
        this.uniqueEvents.push(event);
      }

      this.log('Event tracked', event);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  protected log(message: string, data?: unknown) {
    if (config.debug) {
      console.debug(`[LogRocket] ${message}`, data ? { metadata: data } : '');
    }
  }
}
